export default {
    // 邀请 0
    INVITE: 0,
    // 受邀 1
    INVITEE: 1,
    // 接受 2
    ACCEPT: 2,
    // 被接受 3
    ACCEPTEE: 3,
};
